import Collection from 'ol/Collection';
import Translate from 'ol/interaction/Translate';
import DragPan from 'ol/interaction/DragPan';
import { isMapTranslateBlockedEvent } from '@/features/panel-planning/utils/panelMapSelection';

/**
 * Translate / DragPan 초기 상호작용 플러그인
 * (꼭짓점 편집 Modify 없음)
 *
 * ctx:
 *   initSelectionCollections?: () => void
 *   assignInteractions: ({ modifyInteraction, translateInteraction, dragPanInteraction }) => void
 */
export const panelTranslateModifyPlugin = {
  id: 'panel-translate-modify',

  attach(host, ctx = {}) {
    const map = host.getMap();
    if (!map) {
      return;
    }

    if (typeof ctx.initSelectionCollections === 'function') {
      ctx.initSelectionCollections();
    }

    const groupSelection = ctx.getGroupSelection?.() ?? new Collection();
    const moduleSelection = ctx.getModuleSelection?.() ?? new Collection();

    const translateInteraction = new Translate({
      features: groupSelection,
      condition: event => !isMapTranslateBlockedEvent(event)
    });
    const dragPanInteraction = new DragPan({
      condition: event => event.originalEvent.isPrimary && event.originalEvent.button < 2
    });

    map.addInteraction(translateInteraction);
    map.addInteraction(dragPanInteraction);

    ctx.assignInteractions?.({
      modifyInteraction: null,
      translateInteraction,
      dragPanInteraction,
      groupSelection,
      moduleSelection
    });

    return () => {
      map.removeInteraction(translateInteraction);
      map.removeInteraction(dragPanInteraction);
    };
  }
};
